import {
	ETypeSearchCommonFranchise,
	TYPE_SEARCH_COMMON_FRANCHISE_OPTIONS,
} from '@/constant';
import { memo } from 'react';

import { FilterWithViewAll, Modal, TableWithActions } from '..';
import { useLogic } from './logic';
import { FranchiseItem, IProps } from './type';

export type { FranchiseItem };

const SelectFranchiseModal = (props: IProps) => {
	const { selectedIds, ...rest } = props;

	const {
		filterRef,
		initialValues,
		fetchData,
		loading,
		columns,
		dataSource,
		rowSelection,
		onSaveClick,
	} = useLogic(props);

	return (
		<Modal
			labelButton="저장"
			onClickButton={onSaveClick}
			title="사업장 선택"
			classNames={{ body: '!px-0' }}
			destroyOnClose
			{...rest}
		>
			<div className="bg-white rounded-2xl">
				<div className="mb-5 flex ">
					<FilterWithViewAll
						ref={filterRef}
						initialValues={initialValues}
						rowSelection={rowSelection}
						fetchData={fetchData}
						inputName="searchValue"
						inputClassName="w-[376px]"
						buttonClassName="w-[60px] min-w-0"
						containerClassName="px-6"
						hidePageSize
						hideCheckbox
						isClickSearch
						isShowAutoComplete
						autoCompleteProps={{
							inputClassName: '!w-[375px]',
							containerClassName: 'w-auto',
							options: TYPE_SEARCH_COMMON_FRANCHISE_OPTIONS,
						}}
					>
						<FilterWithViewAll.SelectMasterInfo
							defaultValue={ETypeSearchCommonFranchise.RECRUITER_NAME}
							options={TYPE_SEARCH_COMMON_FRANCHISE_OPTIONS}
							name="searchType"
							containerClassName="w-[200px]"
						/>
					</FilterWithViewAll>
				</div>

				<TableWithActions
					containerClassName="py-0"
					{...{ loading, dataSource, rowSelection, columns }}
					actionHidden
					pagination={false}
					scroll={{ y: 416 }}
					rowKey={'id'}
					isSearching={filterRef?.current?.isSearching}
					rowClassName={(record) => {
						return selectedIds?.includes(record.id)
							? 'bg-gray4 [&>.ant-table-cell-row-hover]:!bg-gray4'
							: '';
					}}
					allowSelectCheckboxOnRow
				/>
			</div>
		</Modal>
	);
};

export default memo(SelectFranchiseModal);
